<template>
  <div class="asset-config-parent pa-0">
    <v-container class="asset-content">
      <v-tabs v-model="selectedTab" vertical class="tab-container" hide-slider>
        <v-tab v-for="(tab, index) in configTabs"
          :key="index"
          class="devive-config-tab"
          :class="{hidden: !tab.supported}"
        >
          <div v-if="tab.supported">
            <v-icon left>
              {{ tab.icon }}
            </v-icon>
            {{ tab.label }}
          </div>
          
        </v-tab>
        
        <v-tab-item 
          v-for="(tab, index) in configTabs" 
          :key="index"
          class="device-tab-content"
        >
          <component 
            :is="tab.comp" 
            :key="tab.comp"
            :asset-list="assetList"
            :org="org"
            @close="close"
          />
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>

import TimeSettings from './sections/TimeSettings.vue'

export default {
  name: 'AssetConfig',
  components: {
    TimeSettings
  },

  props: {
   assetList: {
    type: Array,
    required: true
   },

   org: {
    type: String,
    required: true
   }
  },
  data () {
    return {
    
    }
  },
  computed: {
    configTabs() {
      return [
        {
          comp: 'TimeSettings',
          label: 'Time Settings',
          icon: 'mdi-calendar',
          supported: true
        }
      ]
    }
  },
  watch: {
  
  },  
  mounted() {

  },
  methods: {  
    close() {
      this.$emit('close')
    }
  }
}

</script>

<style lang="scss">
  .asset-config-parent {

    .asset-content {

      .config-status-container {
        padding: 2.5em 1em;
        padding-bottom: 3.5em;
        background: #e0e0e0;
      }

      .config-type-select {
        margin-top: 1em;
        border-right: solid #e0e0e0;
      }

      .config-btn {
        font-weight: 400;
        color: #0f74bb;
        padding: 0;
        height: 0;
        &:hover {
          cursor: pointer;
        }
      }
      .title-bar {
        background: #0f74bb;
        color: white;
        border-bottom: solid grey 2px;
        padding-top: 2em;
        padding-left: 2em;
      }
      .tab-container {
        border: solid grey 2px;
      }
    }
    .close-icon {
      top: 0;
      right: 0;
      position: absolute;
    }
    .v-tab {
      justify-content: start !important;
    }
    .devive-config-tab {
      border-bottom: solid grey 2px !important;
    }
    .devive-config-tab:not(:first-child) {
      border-top: solid grey 2px;
    }
    .v-tab--active {
      background: #8fbaf6 !important;
    }
    .v-tabs--vertical > .v-window {
      border-left: solid grey 2px !important;
    }
  }
  .download-file {
    &:hover {
      cursor: pointer;
    }
  }
  
  .push-down {
    padding-top: 250px;
  }

  .remove-right-padding {
    padding-right: 0;
  }

  .remove-left-padding {
    padding-left: 0;
    margin-top: 0;
  }

  .row-action-container {
    margin: 0;
  }

  .config-action {
    padding: 0;
  }

  .center-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .config-btn {
    font-weight: 400;
    color: #0f74bb;
    padding: 0;
    height: 0;
    &:hover {
      cursor: pointer;
    }
  }

  .file-upload {
    display: block;
    text-align: center;
    padding-top: 0 !important;
  }

  .hidden {
    display: none !important;
  }

  .v-tabs--vertical > .v-tabs-bar .v-tabs-bar__conten {
    border-right: solid grey 2px !important;
  }
</style>